var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "open-salud-about bg-heart" },
    [
      _c(
        "v-row",
        { staticClass: "row container-assistance reverse-sm" },
        [
          _c(
            "v-col",
            {
              staticClass: "main-container-text heightauto",
              attrs: { sm: "6" }
            },
            [
              _c("h3", { staticClass: "title-discount" }, [
                _vm._v(_vm._s(_vm.$t("firstblock.title")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "subtitle-discount" }, [
                _vm._v(_vm._s(_vm.$t("firstblock.subtitle")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "subtitle2-discount" }, [
                _vm._v(_vm._s(_vm.$t("firstblock.subtitle2")))
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "buttonp" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "btn1",
                      attrs: { white: "" },
                      on: {
                        click: function($event) {
                          return _vm.getWellness()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.button_text2) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "main-container-text column-invert heightauto",
              attrs: { sm: "6" }
            },
            [
              _c("h3", { staticClass: "title-discount-invert" }, [
                _vm._v(_vm._s(_vm.$t("firstblock.titleInvert")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "subtitle-discount-invert" }, [
                _vm._v(_vm._s(_vm.$t("firstblock.subtitleInvert")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle-list subtitle-list mt-sm-5 iconlist" },
                [
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("firstblock.iconTitle1")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-calendar") }
                        }),
                        _vm._v(_vm._s(_vm.$t("firstblock.iconTitle2")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-download") }
                        }),
                        _vm._v(_vm._s(_vm.$t("firstblock.iconTitle3")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: {
                            textContent: _vm._s("mdi-credit-card-outline")
                          }
                        }),
                        _vm._v(_vm._s(_vm.$t("firstblock.iconTitle4")))
                      ],
                      1
                    )
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23f4a4b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f4a4b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PrimesaludDiscountsMainBlock.vue
// module id = 4058
// module chunks = 42